import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0a8.99 8.99 0 0 0-7.5 4.029V1.1L.3 2.3V6h1.502C2.98 3.184 5.762 1.2 9 1.2c4.301 0 7.8 3.499 7.8 7.8a7.81 7.81 0 0 1-.148 1.5h1.217c.084-.488.131-.988.131-1.5a9 9 0 0 0-9-9zm0 16.8c-4.301 0-7.8-3.499-7.8-7.8 0-.513.053-1.014.148-1.5H.131A8.827 8.827 0 0 0 0 9a9 9 0 0 0 9 9 8.99 8.99 0 0 0 7.5-4.029V16.9l1.2-1.2V12h-1.502c-1.178 2.816-3.96 4.8-7.198 4.8zm0-1.5a6.3 6.3 0 1 0-.001-12.601A6.3 6.3 0 0 0 9 15.3zm2.25-2.8a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm.069-6.881L12.38 6.68l-5.7 5.7-1.061-1.061 5.7-5.7zM6.75 5.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z" />
  </svg>
);

export default SvgComponent;
